module.exports = __webpack_public_path__ + "img/Logistica-N.65fb0d58.png";